import secureStorage from '../utils/secureStorage'

const AUTH_ERROR_STATUSES = [401, 403, 419, 440]

// While an admin is "logged in as" another user, the admin's own token is
// stashed under this key so it can be handed back. See
// kudukey-kb/STAFF_AUTH.md and helpers/Impersonation.js.
export const IMPERSONATOR_TOKEN_KEY = 'impersonator_token'

// Move the stashed admin token back into place. Returns false when no
// impersonation is in progress.
export const restoreImpersonator = () => {
  const adminToken = secureStorage.getItem(IMPERSONATOR_TOKEN_KEY)
  if (!adminToken) return false
  secureStorage.removeItem(IMPERSONATOR_TOKEN_KEY)
  secureStorage.setItem('logged_user', adminToken)
  return true
}

export const redirectToLogin = (navigate) => {
  if (restoreImpersonator()) {
    // The impersonated session is gone; give the admin their own session
    // back rather than logging them out. If that one has idled out as well,
    // the next request lands here again with nothing left to restore.
    window.location.assign('/users')
    return
  }

  secureStorage.removeItem('logged_user')

  const currentPath = window.location.pathname + window.location.search
  if (currentPath !== '/login') {
    sessionStorage.setItem('login_redirect', currentPath)
  }

  if (typeof navigate === 'function') {
    navigate('/login', { replace: true })
    return
  }

  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

export const handleAuthError = (error, navigate) => {
  const status = error?.response?.status

  if (!AUTH_ERROR_STATUSES.includes(status)) {
    return false
  }

  redirectToLogin(navigate)
  return true
}
